import { computed
       , observable }             from 'mobx' ;

import { restore_lang }           from '../00_assets' ;
import { CTE }                    from '../01_core' ;
import { auth_is_loading
       , init
       , is_logged
       , logged_user
       , ROLE }                   from '../02_api' ;

import { IRoute }                 from './01_model_app_types' ;
import { ROUTES }                 from './03_model_app_screens' ;


let g_m_app_global: MAppGlobal ;

class MAppGlobal
{
              protected initial_page      : IRoute
  @observable protected _cur_page         : IRoute | null
  @observable logged                      : boolean = false ;


  @computed get url ( )
  {
    const page = this.cur_page ;
        
    return (ROUTES[ page.name ] || ROUTES[ CTE.SCREEN.NOT_FOUND ]).url( page.path ) ;
  }


  @computed get cur_page ( ) : IRoute
  { 
    return auth_is_loading( )     ? this.screen( CTE.SCREEN.LOADING )
         : !this.is_logged        ? this.screen( CTE.SCREEN.LOGIN   )
         : this._cur_page !== null? this._cur_page
         :                          this.initial_page ;
  }


  @computed get is_logged ( )
  {
    return is_logged( ) ;
  }

  @computed get user ( )
  {
    return logged_user( ).get( ) ;
  }

  @computed get can_edit_workgroups ( )
  {
    return this.is_admin || this.is_manager ;
  }

  @computed get is_admin ( )
  {
    const user = this.user ;

    return user !== null && user.role.name === ROLE.ADMIN ;
  }

  @computed get is_manager ( )
  {
    const user = this.user ;

    return user !== null && user.role.name === ROLE.MANAGER ;
  }


  static instance ( ) : MAppGlobal
  {
    if ( !g_m_app_global )
         g_m_app_global = new MAppGlobal( window.location.pathname ) ;

    return g_m_app_global ;
  }


  constructor ( initial_url: string )
  {
    this._cur_page    = null ; 
    this.initial_page = this.page_from_url( initial_url.slice( 1 ) ) ;

    if ( this.initial_page.name === CTE.SCREEN.LOGIN || this.initial_page.name === CTE.SCREEN.NOT_FOUND )
         this.initial_page = this.screen( CTE.SCREEN.CLIENTS ) ;

    restore_lang( ) ;
    init( ) ;
  }


  page_from_url ( url: string ) : IRoute
  {
    for ( const page in ROUTES )
          if ( ROUTES[ page ].is_valid( url ) )
               return { name: page as CTE.SCREEN
                      , path: ROUTES[ page ].parse( url ) } ;

    return this.screen( CTE.SCREEN.NOT_FOUND ) ;
  }


  screen ( name: CTE.SCREEN ) 
  {
    return { name, path: {} } ;
  }


  open_page ( new_page: IRoute )
  {
    this._cur_page = new_page ;
  }
}


export const MApp = ( ) => MAppGlobal.instance( ) ;
